import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { BILLING_DISCLOSURES } from "../../data/membership";

export const BillingTermsSummary = () => (
  <section className="py-16" data-testid="billing-terms-summary">
    <div className="max-w-4xl mx-auto px-6 md:px-12">
      <div className="flex items-center gap-3 mb-6">
        <ShieldCheck className="h-6 w-6 text-blue-500" />
        <h2 className="font-heading text-2xl font-bold tracking-tight text-white">
          Billing &amp; Cancellation Terms
        </h2>
      </div>
      <ul className="space-y-2.5">
        {BILLING_DISCLOSURES.map((d) => (
          <li key={d} className="flex items-start gap-3 text-sm text-zinc-400">
            <span className="text-blue-500 mt-0.5">•</span> {d}
          </li>
        ))}
      </ul>
      <p className="text-zinc-500 text-sm mt-6">
        Full details:{" "}
        <Link to="/membership-agreement" className="text-blue-400 hover:text-blue-300 underline" data-testid="link-membership-agreement">
          Membership Agreement
        </Link>{" "}
        ·{" "}
        <Link to="/cancellation-policy" className="text-blue-400 hover:text-blue-300 underline" data-testid="link-cancellation-policy">
          Cancellation Policy
        </Link>
      </p>
    </div>
  </section>
);
